import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ProcessPage = lazy(() => import('../pages/process/page'));
const ExamplesPage = lazy(() => import('../pages/examples/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const RequestPage = lazy(() => import('../pages/request/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const OfferPage = lazy(() => import('../pages/offer/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/process',
    element: <ProcessPage />,
  },
  {
    path: '/examples',
    element: <ExamplesPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/request-preview',
    element: <RequestPage />,
  },
  {
    path: '/offer',
    element: <OfferPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPage />,
  },
  {
    path: '/terms-and-conditions',
    element: <TermsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;